import { render } from "./sizer.vue?vue&type=template&id=0267aeec&scoped=true"
import script from "./sizer.vue?vue&type=script&lang=js"
export * from "./sizer.vue?vue&type=script&lang=js"

import "./sizer.vue?vue&type=style&index=0&id=0267aeec&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0267aeec"]])

export default __exports__